"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxResolveSearchEntitiesArgs = void 0;
var HxStringPair_1 = require("./HxStringPair");
function serializeHxResolveSearchEntitiesArgs(_arg) {
    var output = [];
    output.push(_arg.accountId.toString());
    var resolutionTokensOutput = [];
    _arg.resolutionTokens.forEach(function (item) { return resolutionTokensOutput.push(HxStringPair_1.serializeHxStringPair(item)); });
    output.push(resolutionTokensOutput);
    output.push(_arg.substrateDebugSetting);
    output.push(_arg.substrateFlightsControlledByClient);
    output.push(_arg.requestIssuedTime.valueOf());
    return output;
}
exports.serializeHxResolveSearchEntitiesArgs = serializeHxResolveSearchEntitiesArgs;
